import { PatientDto } from 'app/models/generated'

export const getName = (patient: PatientDto) => {
    return (
        patient.names?.find((name) => name?.preferred)?.name ??
        patient.names?.[0]?.name
    )
}

export const getSex = (patient: PatientDto) => {
    return capitalize(patient.gender)
}

export const getAddress = (patient: PatientDto) => {
    if (!patient?.address || patient.address.length === 0) {
        return 'No address available'
    }

    const physicalAddress = patient.address.find(
        (address) => address?.type === 'physical'
    )
    return physicalAddress?.value || 'No address available'
}

export const capitalize = (string: string) => {
    if (typeof string !== 'string' || string.length === 0) return string
    return string.charAt(0).toUpperCase() + string.slice(1)
}
